export enum ModuleExecutorParmsArgTypeCdText {
  CONFIGURATION = 'Config',
  CONSTANT_DATASET = 'Constant Dataset',
  DATA_SET = 'Dataset',
  DYNAMIC_CONFIG = 'Dynamic Config',
  PERIOD_CODE = 'Period Code',
}
